(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/betslip/assets/javascripts/betslip.js') >= 0) return;  svs.modules.push('/components/lb-ui/betslip/assets/javascripts/betslip.js');
"use strict";


const {
  useEffect,
  useRef,
  useState,
  useCallback
} = React;
const {
  PaymentButton,
  BetslipContext
} = svs.components.lbUi.betslip;
const {
  detect
} = svs.core;
const {
  useWindowSize
} = svs.components.lbUtils;
function isScrolledIntoView(el, parent) {
  if (!el || !parent) {
    return false;
  }
  const rect = el.getBoundingClientRect();
  const elemTop = rect.top;
  const elemBottom = rect.bottom;
  let isVisible;
  if (parent === window) {
    isVisible = elemTop >= 0 && elemBottom <= parent.innerHeight;
  } else {
    const parentRect = parent.getBoundingClientRect();
    isVisible = elemBottom <= parentRect.bottom && elemTop > parentRect.top;
  }
  return isVisible;
}
function isScrolledIntoViewAsRelative(el) {
  const oldPosition = el.style.position;
  el.style.position = '';
  const intoView = isScrolledIntoView(el, window);
  el.style.position = oldPosition;
  return intoView;
}
const Betslip = _ref => {
  let {
    children,
    accountBalance,
    errorMessage,
    isPayable = true,
    isSelfService,
    onPay,
    price,
    getScrollContainer
  } = _ref;
  const priceClassNames = ['betslip-sticky-price'];
  if (isPayable) {
    priceClassNames.push('betslip-sticky-price-is-payable');
  }
  const [isPayButtonVisible, setPayButtonVisible] = useState(false);
  const payButtonRef = useRef();
  const stickyRef = useRef();
  const stickyPlaceholderRef = useRef();
  const isStickyInView = useRef();
  const makeStickyIE11 = useCallback(() => {
    if (detect.browser.ie()) {
      if (isScrolledIntoViewAsRelative(stickyRef.current)) {
        stickyRef.current.style.position = '';
        stickyRef.current.style.width = '';
        stickyPlaceholderRef.current.classList.remove('betslip-sticky-placeholder-active');
        isStickyInView.current = true;
      } else {
        stickyPlaceholderRef.current.classList.add('betslip-sticky-placeholder-active');
        stickyRef.current.style.position = 'fixed';
        if (getScrollContainer && getScrollContainer()) {
          stickyRef.current.width = getScrollContainer();
          stickyRef.current.style.width = window.getComputedStyle(getScrollContainer()).width;
        }
        isStickyInView.current = false;
      }
    }
  }, [getScrollContainer]);
  const {
    width
  } = useWindowSize();
  useEffect(() => {
    if (detect.browser.ie()) {
      if (isStickyInView.current) {
        stickyRef.current.style.width = '';
      } else if (getScrollContainer && getScrollContainer()) {
        stickyRef.current.width = getScrollContainer();
        stickyRef.current.style.width = window.getComputedStyle(getScrollContainer()).width;
      }
    }
  }, [width, getScrollContainer]);
  useEffect(() => {
    let scrollElement = window;
    function onScroll() {
      if (isScrolledIntoView(payButtonRef.current, scrollElement)) {
        setPayButtonVisible(true);
      } else {
        setPayButtonVisible(false);
      }
      makeStickyIE11();
    }
    if (getScrollContainer && getScrollContainer()) {
      scrollElement = getScrollContainer();
    }
    scrollElement.addEventListener('scroll', onScroll);
    return () => {
      scrollElement.removeEventListener('scroll', onScroll);
    };
  }, [getScrollContainer, makeStickyIE11]);
  useEffect(() => {
    makeStickyIE11();
  }, [makeStickyIE11]);
  return React.createElement(BetslipContext.Provider, {
    value: {
      getScrollContainer,
      accountBalance,
      errorMessage,
      isPayable,
      isSelfService,
      onPay,
      price,
      isPayButtonVisible,
      stickyRef,
      stickyPlaceholderRef,
      payButtonRef
    }
  }, children, React.createElement(PaymentButton, {
    ref: payButtonRef
  }));
};
setGlobal('svs.components.lbUi.betslip.Betslip', Betslip);

 })(window);